/* Copyright (c) 2020 Paul Nebel */
/* based on https://medium.com/swlh/a-simple-react-hook-to-prompt-ios-users-to-install-your-wonderful-pwa-4cc06e7f31fa */
/* and https://love2dev.com/pwa/add-to-homescreen-library/ */

import { isEmpty, values, each } from 'lodash';

let platform = {};
const observers = {};

const addToHomescreen = (props = {}) => {
    const defaultPlatform = {
        isCompatible: false,
        version: '1.0.0',
    };

    // triggered by asynchronous event...
    const beforeInstallPrompt = (platform, evt) => {
        evt.preventDefault();
        console.log('capturing the native A2HS prompt', platform);
        platform.beforeInstallPrompt = evt;

        each(values(observers), (obs) => {
            if (obs.onBeforeInstallPrompt) {
                obs.onBeforeInstallPrompt(platform);
            }
        });
    };

    // triggered by asynchronous event...
    const afterSWCheck = (sw) => {
        if (!sw) {
            console.log('no service worker');
            return;
        }    
        checkPlatform(platform);

        each(values(observers), (obs) => {
            if (obs.onCanInstall) {
                obs.onCanInstall(platform);
            }
        });
    };

    const createSingletonPlatform = () => {
        let newPlatform = platform;
        // add all observers
        observers[props.name] = props;
        //prevent duplicate instances
        if (isEmpty(platform)) {
            newPlatform = Object.assign({}, defaultPlatform, props);

            //if no service worker then no add to homescreen
            if ('serviceWorker' in navigator) {
                let manifestEle = document.querySelector(`[rel='manifest']`);

                //if no manifest file then no add to homescreen
                if (!manifestEle) {
                    console.log('Add to homescreen: not displaying callout because no web manifest file present');
                } else {
                    platform = newPlatform;
                    // can only reference window here, otherwise build fails
                    if ('onbeforeinstallprompt' in window) {
                        // make sure this listener is only added once................
                        window.addEventListener(
                            'beforeinstallprompt',
                            (evt) => beforeInstallPrompt.bind(null, platform)(evt),
                            { once: true },
                        );
                    }

                    if ('onappinstalled' in window) {
                        // make sure this listener is only added once....................
                        window.addEventListener(
                            'appinstalled',
                            () => console.log('a2hs', 'installed'),
                            { once: true },
                        );
                    }
                    navigator.serviceWorker.getRegistration().then((sw) => afterSWCheck(sw));
                    return platform;
                }
            } else {
                console.log('Add to homescreen: not displaying callout because service workers are not supported');
            }
        } else {
            return platform;
        }   
    };
    
    const checkPlatform = () => {
        const ua = window.navigator.userAgent;

        platform.isIDevice = /iphone|ipod|ipad/i.test(navigator.platform);
        platform.isSamsung = /Samsung/i.test(ua);
        platform.isFireFox = /Firefox/i.test(ua);
        platform.isOpera = /opr/i.test(ua);
        platform.isEdge = /edg/i.test(ua);
    
        // Opera & FireFox only Trigger on Android
        if (platform.isFireFox) {
            platform.isFireFox = /android/i.test(ua);
        }
    
        if (platform.isOpera) {
            platform.isOpera = /android/i.test(ua);
        }
    
        platform.isChromium = 'onbeforeinstallprompt' in window;
        platform.isInWebAppiOS = window.navigator.standalone === true;
        platform.isInWebAppChrome =
          window.matchMedia('(display-mode: fullscreen)').matches ||
          window.matchMedia('(display-mode: standalone)').matches ||
          window.matchMedia('(display-mode: minimal-ui)').matches;
        platform.isMobileSafari =
          platform.isIDevice &&
          ua.indexOf('Safari') > -1 &&
          ua.indexOf('CriOS') < 0;
        platform.isStandalone = platform.isInWebAppiOS || platform.isInWebAppChrome;
        platform.isiPad = platform.isMobileSafari && ua.indexOf('iPad') > -1;
        platform.isiPhone = platform.isMobileSafari && ua.indexOf('iPad') === -1;
        platform.isCompatible =
          platform.isChromium ||
          platform.isMobileSafari ||
          platform.isSamsung ||
          platform.isFireFox ||
          platform.isOpera ||
          platform.isIDevice;
    };

    platform = createSingletonPlatform();
    return platform;
};

export default addToHomescreen;